import { RootState } from "../store";
import { ChatRoomDto } from "src/shared/services/chat/dto";

export const selectAllRooms = (state: RootState) => state.chat.rooms;

export const selectCurrentRoomId = (state: RootState) =>
  state.chat.currentRoomId;

export const selectCurrentRoom = (state: RootState) => {
  if (!state.chat.currentRoomId) return null;
  return (
    state.chat.rooms.find((room) => room.id === state.chat.currentRoomId) ||
    null
  );
};

export const selectMessagesForRoom = (roomId: string) => (state: RootState) =>
  (state.chat.messages[roomId] || [])
    .slice()
    .sort(
      (a, b) => new Date(a.sentAt).getTime() - new Date(b.sentAt).getTime(),
    );

export const selectCurrentMessages = (state: RootState) => {
  if (!state.chat.currentRoomId) return [];
  return (state.chat.messages[state.chat.currentRoomId] || [])
    .slice()
    .sort(
      (a, b) => new Date(a.sentAt).getTime() - new Date(b.sentAt).getTime(),
    );
};

export const selectIsLoadingRooms = (state: RootState) =>
  state.chat.isLoadingRooms;

export const selectIsLoadingMessages = (state: RootState) =>
  state.chat.isLoadingMessages;

export const selectIsSendingMessage = (state: RootState) =>
  state.chat.isSendingMessage;

export const selectSearchResults = (state: RootState) =>
  state.chat.searchResults;

export const selectIsSearching = (state: RootState) => state.chat.isSearching;

export const selectOfflineQueue = (state: RootState) => state.chat.offlineQueue;

export const selectIsOnline = (state: RootState) => state.chat.isOnline;

export const selectNotifications = (state: RootState) =>
  state.chat.notifications;

export const selectMutedRooms = (state: RootState) => state.chat.mutedRooms;

export const selectTotalUnreadCount = (state: RootState) => {
  return state.chat.rooms.reduce((total, room) => total + room.unreadCount, 0);
};

// For coordinators: group rooms by case
export const selectRoomsGroupedByCase = (state: RootState) => {
  const grouped = new Map<string, ChatRoomDto[]>();

  state.chat.rooms.forEach((room) => {
    const rooms = grouped.get(room.caseId) || [];
    rooms.push(room);
    grouped.set(room.caseId, rooms);
  });

  const groups = Array.from(grouped.entries()).map(([caseId, rooms]) => ({
    caseId,
    caseLabel: rooms[0]?.title, // Use caseId as the label
    rooms,
  }));

  // Sort to pin the pinned case to the top
  const pinnedCaseId = state.chat.pinnedCaseId;
  if (pinnedCaseId) {
    return groups.sort((a, b) => {
      if (a.caseId === pinnedCaseId) return -1;
      if (b.caseId === pinnedCaseId) return 1;
      return 0;
    });
  }

  return groups;
};

export const selectPinnedCaseId = (state: RootState) => state.chat.pinnedCaseId;
